// Renders each questionnaire's own splash content — hero image, headline,
// lede, bullets, CTA — authored per-questionnaire via the admin editor's
// "Splash page" section. Shown as the first step of the Scorecard flow,
// before any questions.

// Bullets are bolded up to their first sentence-ending punctuation so authors
// can write "Takes less than 10 minutes. One question at a time." and get
// the same bold-lead-in look as the original hardcoded copy, with no markup.
function renderBullet(text) {
  const match = /^(.*?[.!?])(\s+([\s\S]*))?$/.exec(text);
  if (!match) return text;
  const [, lead, , rest] = match;
  return (
    <>
      <strong>{lead}</strong>
      {rest ? ` ${rest}` : ''}
    </>
  );
}

export default function ScorecardSplash({ questionnaire, onStart }) {
  const splash = questionnaire.splash || {};
  const headline = splash.headline || questionnaire.title;
  const description = splash.description;
  const bullets = splash.bullets || [];
  const ctaText = splash.ctaText || 'See your score';

  return (
    <div className="landing">
      {splash.heroImage ? (
        <div className="landing-hero-banner">
          <img src={splash.heroImage} alt="" />
          <div className="landing-hero-overlay">
            <h1>{headline}</h1>
          </div>
        </div>
      ) : (
        <div className="page">
          <h1>{headline}</h1>
        </div>
      )}

      <div className="page">
        {description && <p className="lede">{description}</p>}

        {bullets.length > 0 && (
          <ul className="landing-bullets">
            {bullets.map((b, i) => <li key={i}>{renderBullet(b)}</li>)}
          </ul>
        )}

        <div className="nav-row">
          <span className="muted small">No account required.</span>
          <button type="button" onClick={onStart}>{ctaText}</button>
        </div>
      </div>
    </div>
  );
}
